import { initialIndividualState } from "../../../../static/initialState/commonInitialState/individualInitialState";
import { liquidatorInitialState } from "../../../../static/initialState/commonInitialState/liquidatorInitialState";
import { LiquidatorManagerType } from "../../../../static/types/creationCloture/liquidatorManagerType";
import { initialManagerState } from "../../../../static/types/objectInitialState";
import { entityTypes } from "../../../../static/types/objectType";
import IndividualPerson from "../../../commonComponents/IndividualPerson";
import LiquidatorLegalEntity from "./LiquidatorLegalEntity";

type ManagerListProps = {
    checked: boolean,
    managers: LiquidatorManagerType[],
    addButtonText: string,
    removeButtonText: string,
    labelItem?: string,
    setManagers: ( managers: LiquidatorManagerType[] ) => void
    setManagersValidity: ( isValid: boolean ) => void
}

export default function LiquidatorList({
    checked,
    managers,
    labelItem,
    setManagers,
    addButtonText,
    removeButtonText,
    setManagersValidity
}: ManagerListProps) {

    let listValidity: boolean[] = [ false ]

    const addManager = () => {
        setManagers([
            ...managers,
            initialManagerState
        ]);
        listValidity.push( false )
    };

    const removeLastManager = () => {
        if (managers.length > 1) {
            setManagers(managers.slice(0, -1));
        }
        if (listValidity.length > 1) {
            listValidity.slice(0, -1)
        }
    };

    const updateManager = (index: number, updatedManager: LiquidatorManagerType) => {
        const newManagers = [...managers];
        newManagers[index] = updatedManager;
        setManagers(newManagers);
    };

    const toggleManagerType = ( person: "Personne physique" | "Personne morale", index: number) => {

        const newManager: LiquidatorManagerType = person === "Personne physique"
        ? {
            person: "Personne physique", 
            personDetails: initialIndividualState
            } 
        : {
            person: "Personne morale", 
            entityDetails: liquidatorInitialState
            }
        
        updateManager(index, newManager);
    };

    const updateManagersValidity = (index: number, isValid: boolean) => {
        listValidity[index] = isValid;
        setManagersValidity( listValidity.every( valid => valid ) );
    };

    return (
        <>
            <div className="mb-3 row">
                {
                    managers.map((manager, index) =>
                        <div key={index} className="tab-content mb-2">
                            <div className = "mb-3 row pt-3">

                                <div className = "mb-3 row">
                                    <div className = "col-sm-10">
                                        { labelItem ? <h6 className='text-bold'>{ `${labelItem} ${ index + 1 }` }</h6> : "" }
                                    </div>
                                </div>

                                <div className = "mb-3 row">

                                    <label htmlFor="personne" className = "col-sm-2 col-form-label">Personne</label>

                                    <div className = "col-sm-10">
                                        <select
                                            className = "form-select"
                                            id = "person"
                                            onChange = { e => toggleManagerType(
                                                e.target.value as "Personne physique" | "Personne morale",
                                                index
                                            ) }
                                            value = { manager?.person || "" }
                                        >
                                            {
                                                entityTypes.map( option => 
                                                    <option key = { option } value = { option }>
                                                        { option }
                                                    </option>
                                                )
                                            }
                                        </select>
                                    </div>

                                </div>
                            </div>
                                {
                                    manager.person === "Personne physique"
                                    ?
                                    <IndividualPerson
                                        checked = { checked }
                                        onValidationChange = { (isValid: boolean) => updateManagersValidity( index, isValid ) }
                                        individual = { manager.personDetails } 
                                        changeIndividual= { details => {
                                            const updatedManager: LiquidatorManagerType = {
                                                ...manager,
                                                personDetails: { ...manager.personDetails, ...details }
                                            };
                                            updateManager( index, updatedManager );
                                        }}
                                    />
                                    : 
                                    <LiquidatorLegalEntity
                                        checked = { checked }
                                        legalEntity={manager.entityDetails}
                                        onValidationChange={(isValid: boolean) => updateManagersValidity( index, isValid )}
                                        changeLegalEntity={
                                            details => {
                                                const updatedManager: LiquidatorManagerType = {
                                                    ...manager,
                                                    entityDetails: { ...manager.entityDetails, ...details }
                                                };
                                                updateManager( index, updatedManager );
                                            }
                                        }
                                    />
                                }
                        </div>
                    )
                }
            </div>

        <div className="row mb-3">
            <div className="col d-flex justify-content-center align-items-center gap-5">
                <button type='button' onClick = { addManager }> {addButtonText} </button>
                { managers.length > 1 && <button type='button' onClick = { removeLastManager }> {removeButtonText} </button> }
            </div>
        </div>
    </>
  );
};